import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { LOGO_WHITE_URL } from '../../core/constants/basel';
import { APP_NAME } from '../../core/constants/app.constants';
import { CatalogService } from '../../core/services/catalog.service';

@Component({
  selector: 'app-footer',
  imports: [RouterLink],
  templateUrl: './footer.component.html'
})
export class FooterComponent {
  readonly catalog = inject(CatalogService);
  readonly logo = LOGO_WHITE_URL;
  readonly displayName = APP_NAME;
  readonly year = new Date().getFullYear();
}
